import { render } from "./index.vue?vue&type=template&id=1e74da12&scoped=true&ts=true"
import script from "./view-model/index.ts?vue&type=script&lang=ts"
export * from "./view-model/index.ts?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=1e74da12&lang=less&scoped=true"

import exportComponent from "D:\\code\\customer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e74da12"],['__file',"src/components/common-button/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e74da12"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e74da12', __exports__)) {
    console.log('reload')
    api.reload('1e74da12', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=1e74da12&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('1e74da12', render)
  })

}


export default __exports__